<template>
  <div>
    <b-form-select
      v-if="isForm"
      :options="options"
      v-model="model"
      @change="onChange"
    />
    <b-form-select
      v-else
      :options="option"
      v-model="model"
      @change="onChange"
    />
  </div>
</template>
<script>
export default {
  name: "PdfAttachmentMode",

  props: {
    model: Number,
    isForm: Boolean,
  },

  data() {
    return {
      options: [
        { value: 0, text: "Sem Anexo" },
        { value: 1, text: "Completo" },
        { value: 2, text: "Sem fotos" },
        { value: 3, text: "Sem campos vazios" },
        { value: 4, text: "Sem fotos / sem campos vazios" },
        { value: 5, text: "Apenas campos com pendências em aberto" },
        { value: 6, text: "Exportar com pendências" },
      ],
      option: [
        { value: 1, text: "Completo" },
        { value: 2, text: "Sem fotos" },
        { value: 3, text: "Sem campos vazios" },
        { value: 4, text: "Sem fotos / Sem campos vazios" },
        { value: 5, text: "Apenas campos com pendências em aberto" },
        { value: 6, text: "Exportar com pendências" },
      ],
    };
  },

  methods: {
    onChange() {
      this.$emit("update:model", this.model);
    },
  },
};
</script>
